import React from "react";

import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import {
  CategoryScale,
  ChartDataset,
  Chart as ChartJS,
  ChartOptions,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { AdvancedProps } from "../sparkline/SparkLineTypes";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler);

type SparkLineChartProps = {
  dataArray: number[];
  advancedProps: AdvancedProps;
  lineColor?: string;
  lineWidth?: number;
};

const options: ChartOptions<"line"> = {
  animation: {
    duration: 0,
  },
  plugins: {
    tooltip: {
      enabled: false,
    },
    legend: {
      display: false,
    },
  },
  interaction: {
    intersect: false,
  },
  scales: {
    x: {
      display: false,
    },
    y: {
      display: false,
    },
  },
};

const SparkLineChart: React.FC<SparkLineChartProps> = ({
  dataArray,
  advancedProps,
  lineColor,
  lineWidth,
}) => {
  const { data: baselineDatasetData } = useGetRecentData([advancedProps.baselineDataset!], {
    count: advancedProps.count,
    refTime: advancedProps.referenceTime,
    options: {
      refetchInterval: advancedProps.updateFrequency ? advancedProps.updateFrequency * 1000 : 0,
      enabled: !!advancedProps.baselineDataset,
    },
  });
  const baselineValues = baselineDatasetData?.[0]?.data.map(item => item.value) || [];
  const baselineDatasetDataChart: ChartDataset<"line", number[]> = {
    data: baselineValues,
    borderColor: advancedProps.baselineColor,
    borderWidth: advancedProps.baselineWidth,
    pointStyle: false,
  };
  const datasets = baselineDatasetData ? [baselineDatasetDataChart] : [];

  return (
    <Line
      data={{
        labels: dataArray.map(() => 1),
        datasets: [
          {
            data: dataArray,
            borderColor: lineColor,
            borderWidth: lineWidth,
            pointStyle: false,

            fill: {
              target: 1,
              above: advancedProps.fillAboveColor,
              below: advancedProps.fillBelowColor,
            },
          },
          ...datasets,
        ],
      }}
      options={options}
      style={{ flex: 2}}
    />
  );
};

export default SparkLineChart;
